import React, { Component } from 'react';
import { Button, Form, FormField } from 'semantic-ui-react';
import CopyLink from '../FileUpload/CopyLink';
import { PostFormData } from './../../api/Service';

class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filePath: '',
            uploadedfile: [],
            type: '',
            subtype: '',
            key: '',
            file_path: ''
        }
    }


    onChange(e) {
        let filePath = '';
        filePath = URL.createObjectURL(e.target.files[0]);
        this.setState({ filePath });
    }


    onSubmit(e) {

        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;

        let data = new FormData(e.target);
        var url = `api/upload/${key}/${this.props.key_id}/${this.props.type}/${this.props.subtype}/${user_id}`;
        PostFormData(url, data)
            .then(function (data) {
                this.props.onChange(data);
            }.bind(this));
    }



    render() {
        return (
            <div>
                <br />
                <hr />
                <br />
                <Form onSubmit={this.onSubmit.bind(this)} encType="multipart/form-data">

                    <Form.Group>

                        <Form.Field>
                            <label>File upload</label>
                            <input
                                type="file"
                                placeholder='Choose a file'
                                name="fileUpload"
                                multiple={true}
                                onChange={this.onChange.bind(this)}
                            />
                        </Form.Field>

                        <Form.Field>
                            <label>&nbsp;</label>
                            <Button type="submit">Upload File</Button>
                        </Form.Field>
                    </Form.Group>
                </Form>
                
            </div>
        )
    }
}

export default FileUpload;


// WEBPACK FOOTER //
// ./src/HomeComponents/Notice/FileUpload.js